"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.futurePredeploys = exports.predeploys = void 0;
exports.predeploys = {
    OVM_L2ToL1MessagePasser: '0x4200000000000000000000000000000000000000',
    OVM_DeployerWhitelist: '0x4200000000000000000000000000000000000002',
    L2CrossDomainMessenger: '0x4200000000000000000000000000000000000007',
    OVM_GasPriceOracle: '0x420000000000000000000000000000000000000F',
    L2StandardBridge: '0x4200000000000000000000000000000000000010',
    OVM_SequencerFeeVault: '0x4200000000000000000000000000000000000011',
    L2StandardTokenFactory: '0x4200000000000000000000000000000000000012',
    OVM_L1BlockNumber: '0x4200000000000000000000000000000000000013',
    OVM_ETH: '0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000',
    WETH9: '0x4200000000000000000000000000000000000006',
};
exports.futurePredeploys = {
    System0: '0x4200000000000000000000000000000000000042',
    System1: '0x4200000000000000000000000000000000000014',
};
//# sourceMappingURL=predeploys.js.map